export default __webpack_public_path__ + "static/media/mint.b83a3d2e.jpg";